export const TRAFFIC_DISABLED_BY_FEATURE_FLAG = 'traffic_disabled_by_feature_flag';

export async function isTrafficDisabledByFeatureFlag(response: Response): Promise<boolean> {
  if (response.ok) {
    return false;
  }

  try {
    const body = await response.clone().json();
    return body?.detail?.error === TRAFFIC_DISABLED_BY_FEATURE_FLAG;
  } catch {
    return false;
  }
}

/** Reload so SSR re-evaluates the Web offline flag (WEB-193400). */
export function handleTrafficDisabledByFeatureFlag(): void {
  window.location.reload();
}

export async function handleTrafficDisabledResponse(response: Response): Promise<boolean> {
  if (!(await isTrafficDisabledByFeatureFlag(response))) {
    return false;
  }

  handleTrafficDisabledByFeatureFlag();
  return true;
}
